import React from "react";
import styles from "./DropdownMenuTitle.module.css";

export const DropdownMenuTitle = ({
  label,
}: {
  label: string;
}): JSX.Element => <div className={styles.label}>{label}</div>;
